// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3bQRO","footer":"ModalFilter_footer__13cML"};